<template>
	<div :id="id" v-bind:class="agregar ? 'agregar' : 'eliminar'">
		<b-input-group size="sm">
			<b-input-group-prepend size="sm">
				<b-button v-if="agregar" size="sm" variant="outline-secondary" @click="agregarCampo"><i class="fas fa-clone fa-fw" /></b-button>
				<b-button v-if="!agregar" size="sm" variant="outline-secondary" @click="eliminarCampo"><i class="fas fa-times fa-fw" /></b-button>
				<b-button size="sm" variant="outline-secondary" @click="agregarGlosa"><i class="fas fa-plus fa-fw" /> Agregar</b-button>
				<b-input-group-text size="sm">{{ cliente._source.CLIENT_NAME }}</b-input-group-text>
			</b-input-group-prepend>
			<b-form-input :id="'monto_' + id" :name="'monto_' + id" type="number" size="sm" 
				placeholder="Ingresar monto" class="refacturacion-monto" disabled></b-form-input>
		</b-input-group>
	</div>
</template>
<script lang="ts">

	import { uuid } from "vue-uuid"
	import $ from "jquery"

	export default {
		name: "IngresaMonto",
		props: {
			cliente: Object,
			agregar: Boolean,
		},
		data() {
			return {
				id: ""
			}
		},
        created() {

			// ID unico asociado a este objeto
			this.id = uuid.v1()
		},
		methods: {

			agregarCampo() {

				this.$emit("evento-agregar-campo", this.cliente._id)
			},

			eliminarCampo() {

				$("#" + this.id).remove()
				this.$emit("evento-eliminar-campo", this.id)
			},

			agregarGlosa() {

				this.$emit("evento-agregar-glosa", { cliente: this.cliente._id, id: this.id })
			}
		}
	}
</script>
<style scoped>

	.agregar {
		padding-top: 10px;
	}

	.eliminar {
		margin-left: 15px !important;
		padding-top: 5px;
	}

</style>
